const userPayment = {
  userPayments: 'Платежи администратора',
  showing: 'показано',
  userPaymentsOf: 'платежи',
  noUserPaymentsFound: 'Платежи пользователя не найдены',
  table: {
    bonusPayment: 'Бонусный платеж',
    regularPayment: 'Обычный платеж'
  },
  actionsDropdown: {
    edit: 'Редактировать платеж',
    delete: 'Удалить платеж',
    editInvoice: 'Редактировать счет-фактуру',
    deleteInvoice: 'Удалить счет-фактуру',
  },
  tableDropdown: {
    quickActions: 'Быстрые действия',
    refresh: 'Обновить',
    exportUserPayments: 'Экспортировать',
    exportUserPaymentsCurrent: 'Экспортировать текущий',
  },
  modal: {
    editPayment: 'Редактировать платеж',
    email: 'Электронная почта',
    amount: 'Сумма',
    date: 'Дата',
    paymentType: 'Тип платежа',
    paymentDetails: 'Информация о платеже',
    successDelete: 'Платеж успешно удален',
    invoiceUpdated: 'Счет-фактура успешно обновлена',
    invoiceDeleted: 'Счет-фактура успешно удалена',
    successUpdate: 'Платеж успешно обновлен',
  }
};

export default userPayment;
